module.exports = __webpack_public_path__ + "img/angststoerungen_640.8ac1b18b.png";